import { render, staticRenderFns } from "./vote-dialog.vue?vue&type=template&id=2f1cb580&scoped=true"
import script from "./vote-dialog.vue?vue&type=script&lang=js"
export * from "./vote-dialog.vue?vue&type=script&lang=js"
import style0 from "./vote-dialog.vue?vue&type=style&index=0&id=2f1cb580&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1cb580",
  null
  
)

export default component.exports